var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group"},_vm._l((_vm.list),function(item){return _c('div',{key:item.id,staticClass:"user-row"},[_c('useradminvolunteerview',{attrs:{"volunteer":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }